<!--
 * @Description: 档案审批弹出框信息展示
 * @Author: ma.cq
 * @Date: 2019-11-08 17:05:50
 * @LastEditors: YY
 * @LastEditTime: 2023-11-15 15:58:43
 -->
<template>
  <el-form label-width="100px">
    <el-row>
      <el-col :span="24">
        <el-form-item label="认证经营组织">{{info.orgName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="类型">{{statusFormatter(info.status)}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="用户名">{{info.userName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册手机号">{{info.mobile}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="营业执照">{{info.businessLicence}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="客户名称">{{info.customerName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业性质">{{info.natureOfBusiness}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="公司所在地">{{info.provinceName + info.cityName + info.areaName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="法人代表">{{info.corporateRepresentative}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="登记机关">{{info.registrationAuthority}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册地址">{{info.registeredAddress}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系人">{{info.contactName}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经营期限">{{info.dueDate}}</el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="收单地址">{{info.billAddress}}</el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="联系电话">{{info.contactPhone}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="电子邮箱">{{info.email}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="收单地址">{{(info.billAddressName || '').split('/').join('')}}{{info.billAddress}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="注册时间">{{(info.foundDate||'').slice(0,10)}}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="收货地址">{{info.deliveryPlace}}</el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="企业证件" style="margin-top: 20px">

          <!-- 卡片 1: 营业执照 -->
          <el-card shadow="never" class="img-card" v-if="info.businessPhoto">
            <!-- 判断是否为 PDF -->
            <div v-if="isPdf(info.businessPhoto)" class="pdf-preview-box" @click="handlePreview(info.businessPhoto)">
              <i class="el-icon-document" style="font-size: 48px; color: #F56C6C;"></i>
              <span class="pdf-label">点击查看 PDF</span>
            </div>
            <img-view
              v-else
              :transfrom="true"
              :src="info.businessPhoto"
              class="img-view"
              @click="handlePreview(info.businessPhoto)"
              style="cursor: pointer;"
            ></img-view>

            <p>证件类型：营业执照</p>
            <p>证件有效期：{{ formatDateRange(info.foundDate, info.dueDate) }}</p>
          </el-card>

          <!-- 卡片 2: 授权协议书 -->
          <el-card shadow="never" class="img-card" v-if="info.electronicPhoto">
            <div v-if="isPdf(info.electronicPhoto)" class="pdf-preview-box" @click="handlePreview(info.electronicPhoto)">
              <i class="el-icon-document" style="font-size: 48px; color: #F56C6C;"></i>
              <span class="pdf-label">点击查看 PDF</span>
            </div>
            <img-view
              v-else
              :transfrom="true"
              :src="info.electronicPhoto"
              class="img-view"
              @click="handlePreview(info.electronicPhoto)"
              style="cursor: pointer;"
            ></img-view>

            <p>证件类型：商城通用授权协议书</p>
            <p>证件有效期：{{ info.commissionStatus ? formatDateRange(info.commissionStartTime, info.commissionEndTime) : '无期限' }}</p>
          </el-card>

          <!-- 列表: 其他证件 -->
          <div
            v-for="(item, index) in parseOtherPhotos(info.otherPhoto)"
            :key="`other-${index}`"
            class="img-view-float-wrapper"
            style="display: inline-block; margin-right: 10px; margin-bottom: 10px;"
          >
            <!-- 判断是否为 PDF -->
            <div v-if="isPdf(item)" class="pdf-preview-box" @click="handlePreview(item)">
              <i class="el-icon-document" style="font-size: 40px; color: #F56C6C;"></i>
              <span class="pdf-label">PDF</span>
            </div>
            <img-view
              v-else
              :transfrom="true"
              :src="item"
              class="img-view-float"
              @click="handlePreview(item)"
              style="cursor: pointer;"
            ></img-view>
          </div>
        </el-form-item>
        <el-form-item label="资质证件">
          <el-card v-for="(item, index) in hPhotos" :key="`photos-${index}`" shadow="never" class="img-card" @click.native="handleCardClick(item)" >
            <img-view
              v-if="!isPdf(item.url)"
              :transfrom="true"
              :src="item.url"
              class="img-view"></img-view>
            <!-- PDF 情况：显示默认图标 -->
            <div v-else class="pdf-placeholder">
              <i class="el-icon-document" style="font-size: 48px; color: #F56C6C;"></i>
              <span style="display:block; margin-top:10px; color:#909399;">点击预览 PDF</span>
            </div>
              <p>证件类型：{{item.name}}</p>
              <p>证件有效期：{{item.startTime === '无期限' ? item.startTime : `${item.startTime}至${item.endTime}`}}</p>
          </el-card>
          <!-- 全局预览对话框 (放在组件底部) -->
          <el-dialog
            title="文件预览"
            :modal="false"
            :visible.sync="previewDialogVisible"
            width="80%"
            top="5vh"
          >
            <!-- 如果是图片 -->
            <div v-if="currentPreviewType === 'image'" style="text-align: center;">
              <img :src="currentPreviewUrl" style="max-width: 80%;" :z-index="-1"/>
            </div>
            <!-- 如果是 PDF -->
            <iframe
              v-else
              :src="currentPreviewUrl"
              width="100%"
              height="500px"
            ></iframe>
          </el-dialog>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="info.status === 3">
        <el-form-item label="备注">{{info.remark}}</el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import ImgView from '@/components/imgView'

export default {
  name: 'InfoForm',
  components: { ImgView },
  props: ['info'],
  data () {
    return {
      previewDialogVisible: false,
      currentPreviewUrl: '',
      currentPreviewType: 'image' // 'image' or 'pdf'
    }
  },
  computed: {
    hPhotos () { // 资质
      let arrPhotos = []
      if (this.info) {
        const arr = this.info.auditHazardousInfo && this.info.auditHazardousInfo.map((item, index) => {
          return {
            url: item.url,
            name: item.registrationNumber,
            startTime: item.startDate,
            endTime: item.endDate
          }
        })
        arrPhotos = arr
      }
      return arrPhotos
    }
  },
  methods: {
    // 1. 安全解析 JSON (防止 info.otherPhoto 为空或格式错误报错)
    parseOtherPhotos (str) {
      if (!str) return []
      try {
        const parsed = typeof str === 'string' ? JSON.parse(str) : str
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        console.error('解析 otherPhoto 失败', e)
        return []
      }
    },
    // 3. 格式化日期辅助函数
    formatDateRange (start, end) {
      const s = start ? String(start).slice(0, 10) : ''
      const e = end ? String(end).slice(0, 10) : ''
      if (!s && !e) return '-'
      return `${s}至${e}`
    },
    // 4. 触发预览
    handlePreview (url) {
      if (!url) return
      this.currentPreviewUrl = url
      if (this.isPdf(url)) {
        this.currentPreviewType = 'pdf'
        this.previewDialogVisible = true
      } else {
        // 如果图片有专门的查看器逻辑，也可以在这里调用，否则直接用 dialog 显示
        this.currentPreviewType = 'image'
        // this.previewDialogVisible = true
      }
    },
    // 判断是否为 PDF
    isPdf (url) {
      if (!url) return false
      return url.toLowerCase().endsWith('.pdf')
    },
    // 卡片点击处理
    handleCardClick (item) {
      this.currentPreviewUrl = item.url
      if (this.isPdf(item.url)) {
        this.currentPreviewType = 'pdf'
        this.previewDialogVisible = true
      } else {
        // 如果图片有专门的查看器逻辑，也可以在这里调用，否则直接用 dialog 显示
        this.currentPreviewType = 'image'
        // this.previewDialogVisible = true
      }
    },
    statusFormatter (status) {
      const arr = ['', '待审核', '审核通过', '审核未通过']
      return arr[status]
    }
  }
}
</script>

<style lang="scss" scoped>
.img-view {
  width: 150px;
  height: 150px;
}
.img-card {
  float: left;
  width: 330px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.img-view-float {
  float: left;
  margin-right: 10px;
}
</style>
